import { AttachmentAction } from '../attachment/actions';
import { LockedByInfo } from './reducer';

export enum AssessmentRunFeedbackTypeKeys {
    SAVE_ASSESSMENT_RUN_FEEDBACK_CONTENT = 'assessmentRunFeedback/SAVE_ASSESSMENT_RUN_FEEDBACK_CONTENT',
    ASSESSMENT_RUN_FEEDBACK_LOADED = 'assessmentRunFeedback/ASSESSMENT_RUN_FEEDBACK_LOADED',
    LOAD_ASSESSMENT_RUN_FEEDBACK = 'assessmentRunFeedback/LOAD_ASSESSMENT_RUN_FEEDBACK',
    SET_ASSESSMENT_RUN_FEEDBACK_LOCKED = 'assessmentRunFeedback/SET_ASSESSMENT_RUN_FEEDBACK_LOCKED',
    LOCK_ASSESSMENT_RUN_FEEDBACK = 'assessmentRunFeedback/LOCK_ASSESSMENT_RUN_FEEDBACK',

    GET_ASSESSMENT_RUN_FEEDBACK_FAILED = 'assessmentRunFeedback/GET_ASSESSMENT_RUN_FEEDBACK_FAILED',
    SAVE_ASSESSMENT_RUN_FEEDBACK_FAILED = 'assessmentRunFeedback/SAVE_ASSESSMENT_RUN_FEEDBACK_FAILED',
    LOCK_ASSESSMENT_RUN_FEEDBACK_FAILED = 'assessmentRunFeedback/LOCK_ASSESSMENT_RUN_FEEDBACK_FAILED'
}

export type AssessmentRunFeedbackAction = AssessmentRunFeedbackLoadedAction
    | SaveAssessmentRunFeedbackContentAction
    | AttachmentAction
    | LoadAssessmentRunFeedbackAction
    | SetAssessmentRunFeedbackAction;

interface AssessmentRunFeedbackLoadedAction {
    featureId: string;
    assessmentRunFeedback: any;
    type: AssessmentRunFeedbackTypeKeys.ASSESSMENT_RUN_FEEDBACK_LOADED;
}

export interface SaveAssessmentRunFeedbackContentAction {
    featureId: string;
    assessmentRunFeedbackContent: any;
    type: AssessmentRunFeedbackTypeKeys.SAVE_ASSESSMENT_RUN_FEEDBACK_CONTENT;
}

export interface LoadAssessmentRunFeedbackAction {
    type: AssessmentRunFeedbackTypeKeys.LOAD_ASSESSMENT_RUN_FEEDBACK;
}

export interface SetAssessmentRunFeedbackAction {
    type: AssessmentRunFeedbackTypeKeys.SET_ASSESSMENT_RUN_FEEDBACK_LOCKED;
    lockedByInfo: LockedByInfo;
}

export interface LockAssessmentRunFeedbackAction {
    featureId: string;
    lockItem: boolean;
    type: AssessmentRunFeedbackTypeKeys.LOCK_ASSESSMENT_RUN_FEEDBACK;
}

export const assessmentRunFeedbackLoaded = (featureId: string, assessmentRunFeedback: any): AssessmentRunFeedbackLoadedAction => ({
    featureId,
    assessmentRunFeedback,
    type: AssessmentRunFeedbackTypeKeys.ASSESSMENT_RUN_FEEDBACK_LOADED,
});

export const saveAssessmentRunFeedbackContent = (featureId: string,
    assessmentRunFeedbackContent: string): SaveAssessmentRunFeedbackContentAction => ({
    featureId,
    assessmentRunFeedbackContent,
    type: AssessmentRunFeedbackTypeKeys.SAVE_ASSESSMENT_RUN_FEEDBACK_CONTENT,
});

export const loadAssessmentRunFeedback = (): LoadAssessmentRunFeedbackAction => ({
    type: AssessmentRunFeedbackTypeKeys.LOAD_ASSESSMENT_RUN_FEEDBACK,
});

export const setAssessmentRunFeedbackLocked = (lockedByInfo: LockedByInfo): SetAssessmentRunFeedbackAction => ({
    lockedByInfo,
    type: AssessmentRunFeedbackTypeKeys.SET_ASSESSMENT_RUN_FEEDBACK_LOCKED,
});

export const lockAssessmentRunFeedback = (featureId: string, lockItem: boolean): LockAssessmentRunFeedbackAction => ({
    featureId,
    lockItem,
    type: AssessmentRunFeedbackTypeKeys.LOCK_ASSESSMENT_RUN_FEEDBACK,
});
